import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ModalAction from '@/components/ModalAction';
import { fetchAPI } from '@/api';
import { AuthState } from '@/types';
import { Loader } from '@/components/Loader';

const RemoveMemberModal = ({ modalOpen, setModalOpen, projectId, member, setFilters }: any) => {
	const auth = useSelector((state: { auth: AuthState }) => state.auth);

	const [isLoading, setIsLoading] = useState(false);

	const onClearModal = () => {
		setFilters(undefined);
		setModalOpen(false);
		setTimeout(() => {
			setIsLoading(false);
		}, 400);
	};

	const onMemberRemove = () => {
		const removeMember = async () => {
			setIsLoading(true);

			const response = await fetchAPI("/project/team/member/remove", auth?.user?.token, {
				projectId,
				telegramUserId: member.telegramUserId,
			});

			if (!response.ok) {
				throw new Error(`This is an HTTP error: The status is ${response.status}`);
			}

			let data = await response.json();

			if (data) {
				setFilters(null);
				onClearModal();
			}

			setIsLoading(false);
		}
		removeMember();
	}

	return (
		<ModalAction
			id="remove-member-modal"
			modalOpen={modalOpen}
			setModalOpen={setModalOpen}
			onModalClose={() => onClearModal()}
			size={undefined}
		>
			{member && (
				<>
					<h2 className="h2 mb-4 pr-16 md:pr-20 leading-[0.9]">
						Are you sure you want to remove {member.name} (id{member.telegramUserId}) from your team?
					</h2>
				</>
			)}
			{isLoading && (
				<div className="text-brand-green w-[50px] h-[50px] my-1 mx-auto">
					<Loader />
				</div>
			)}
			<button className="btn-primary w-full mt-8" onClick={() => onClearModal()}>
				<span className="pointer-events-none">Keep</span>
			</button>
			<button className="btn-primary-inverted w-full mt-4" onClick={() => onMemberRemove()} disabled={isLoading}>
				<span className="pointer-events-none">Remove</span>
			</button>
		</ModalAction>
	);
};

export default RemoveMemberModal;
